module.exports = "https://static.web-explore.prod.greetz-nl.net/_next/static/images/upcoming-occasion-desktop-balloons-dff4850debe417f8d7ed49cccaaa3ef7.svg";